import React from "react";
import "./Login.scss";

const Login = () => {
  return <div>Login</div>;
};

export default Login;
